import { DefaultTheme } from 'styled-components'
import { ThemeName } from '../constants'

export const isExternalLink = (url: string): boolean => {
  if (!url) return
  return !url.startsWith('/')
}

export const linkIsActive = (url: string, currentPath: string): boolean => {
  return currentPath === url
}

export const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const isEmail = (email: string): boolean => {
  return emailPattern.test(email)
}

export const isServer = () => typeof window === 'undefined' || !window.document

export const getThemeColor = (themeObject: DefaultTheme, theme: ThemeName, shade: number) => {
  if (!theme || !themeObject.colors?.[theme]) return themeObject.colors?.black?.[shade]
  return themeObject.colors?.[theme]?.[shade] || themeObject.colors.black[3]
}
